import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialogConfig } from '@angular/material/dialog'
import { AirbnbUpdatePriceSettingsDialogComponent } from './airbnb-update-price-settings-dialog.component'
import { Connection } from '@tv3/store/connection/connection.model'
import { SidePanelService } from '@tv3/services/utils/side-panel.service'

@Injectable({
  providedIn: SharedModule,
})
export class AirbnbUpdatePriceSettingsDialogService {
  constructor(private sidePanel: SidePanelService) {}

  open(connection: Connection) {
    const defaultConfig: MatDialogConfig = {
      panelClass: ['modal-airbnb-connection-details', 'overlay-20', 'modal', 'side-modal-lg', 'right'],
      data: { connection },
    }

    return this.sidePanel.openSide(AirbnbUpdatePriceSettingsDialogComponent, defaultConfig)
  }
}
